import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock, Truck } from "lucide-react";
import { SITE } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const links = [["/", t.nav.home, "home"], ["/about", t.nav.story, "our-story"], ["/services", t.nav.services, "produce-services"], ["/gallery", t.nav.gallery, "gallery"], ["/contact", t.nav.contact, "contact"]];
  return (
  <footer className="relative overflow-hidden bg-[var(--green-deep)] text-[#eef2e6]" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 pb-10 pt-20 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <img src="/logo.png" alt="Sebastian's Produce" className="h-24 w-auto rounded-xl bg-white p-2" />
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-white/70">{t.footer.desc}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={`mailto:${SITE.email}`} className="btn-pill bg-white text-[var(--green-deep)] hover:bg-[var(--lime)]" data-testid="footer-email-btn">
              <Mail size={16} /> {SITE.email}
            </a>
            <a href={SITE.phoneHref} className="btn-pill border border-white/25 hover:border-white/60" data-testid="footer-phone-btn">
              <Phone size={16} /> {SITE.phone}
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="eyebrow !text-[var(--lime)]">{t.footer.navigate}</p>
          <ul className="mt-5 space-y-3 text-[15px]">
            {links.map(([to, label, id]) => (
              <li key={to}>
                <Link to={to} className="link-underline text-white/80 hover:text-white" data-testid={`footer-link-${id}`}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="eyebrow !text-[var(--lime)]">{t.footer.terminal}</p>
          <ul className="mt-5 space-y-4 text-[15px] text-white/80">
            <li className="flex gap-3"><MapPin size={18} className="mt-0.5 shrink-0 text-[var(--lime)]" /><a href={SITE.mapsUrl} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-address">{SITE.address}<br />{SITE.city}</a></li>
            <li className="flex gap-3"><Clock size={18} className="mt-0.5 shrink-0 text-[var(--lime)]" /><span data-testid="footer-hours">{t.footer.open} {t.site.hours}</span></li>
            <li className="flex gap-3"><Truck size={18} className="mt-0.5 shrink-0 text-[var(--lime)]" /><span data-testid="footer-delivery">{t.footer.deliveries} {t.site.delivery}</span></li>
          </ul>
        </div>
      </div>

      <div className="mt-20 select-none">
        <p className="font-display text-[12vw] font-800 leading-[0.85] text-white/[0.07] lg:text-[9.5vw]" style={{ fontWeight: 800 }}>
          SEBASTIAN'S
        </p>
      </div>

      <div className="mt-6 flex flex-col gap-3 border-t border-white/10 pt-6 font-mono-label text-[10.5px] text-white/50 md:flex-row md:items-center md:justify-between">
        <span>© {new Date().getFullYear()} Sebastian's Produce Inc. · {t.footer.copy}</span>
        <span>{t.footer.family} · <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Admin</Link></span>
      </div>
    </div>
  </footer>
  );
};
